import { cn } from '@calendar/lib/utils';
import type { Event, Category } from '@/types/calendar';
import { displayCategories, groupEventsByDate } from '@calendar/lib/utils';
import Container from '../custom/container';

interface ViewListProps {
  events: Event[]
  className?: string
  categories: Category[]
}

export default function ViewList({ events, className, categories }: ViewListProps) {
  const groupedEvents = groupEventsByDate(events);

  return (
    <Container className={cn(className, 'no-padding-mobile')}>
      <div className={cn('event-list', className)}>
        {Object.entries(groupedEvents).map(([ date, dayEvents ]) => {
          const [ monthName,dayName, dayNumber, fullDate ] = date.split('-');

          return (
            <div key={date} data-date={fullDate} className="event-date-container">
              <div className="event-date">
                <div className="event-month">{monthName}</div>
                <div className="event-day-number">{dayNumber}</div>
                <div className="event-day-name">{dayName}</div>
              </div>

              <div>
                {dayEvents.map((event, index) => (
                  <div key={event.id} className={cn('event-item', index !== 0 && 'event-item--with-border')}>
                    {(event.season || event.organization) && (
                      <div className="event-category">{displayCategories(event.categories, categories)}</div>
                    )}

                    <h3 className="event-title">
                      <a href={event.url}>
                        <span className="event-link-overlay"></span>
                        {event.title}
                      </a>
                    </h3>

                    <div className="event-details">
                      <span className="event-time">{event.time}</span>
                      <br />
                      {event.venue}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
}
